module.exports = __webpack_public_path__ + "static/media/darkread.68cf93f8.svg";